'use client';

import dynamic from 'next/dynamic';

export { useReferralLoginCompletion } from '@/features/referral/use-referral-login-completion';
export const LoginWithInvitedCodeModal = dynamic(() => import('@/features/referral/invitation-dialog'), { ssr: false });

export const ReferralDialog = dynamic(
    () => import('@/features/referral/ReferralDialog').then((module) => module.ReferralDialog),
    { ssr: false }
);
export { useReferralLink } from '@/features/referral/useReferralLink';
export { useReferralRewards } from '@/features/referral/useReferralRewards';
